import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, OnDestroy, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { VideoLogService } from '../../../services/video-log.service';
import { BaseComponent } from '../../base.component';
var VideoLogInfoComponent = /** @class */ (function (_super) {
    tslib_1.__extends(VideoLogInfoComponent, _super);
    function VideoLogInfoComponent(_vcf, videoLogService, cdr) {
        var _this = _super.call(this, _vcf, true) || this;
        _this.videoLogService = videoLogService;
        _this.cdr = cdr;
        _this.jurisMap = {
            1: 'State',
            2: 'Turnpike',
            3: 'Agency Owned',
            5: 'Non-State Federal Aid Roads',
            6: 'Toll Bridges',
            8: 'Local Roads'
        };
        _this.refreshInfo = _this.videoLogService.refreshInfo;
        _this.unsubscribe$ = new Subject();
        return _this;
    }
    VideoLogInfoComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.videoLogService.newOffset.pipe(takeUntil(this.unsubscribe$), distinctUntilChanged()).subscribe(function (_) {
            _this.cdr.detectChanges();
        });
        this.videoLogService.newPlayerState.pipe(takeUntil(this.unsubscribe$), distinctUntilChanged()).subscribe(function (_) {
            _this.cdr.detectChanges();
        });
        this.videoLogService.refreshInfo.subscribe(function () {
            _this.cdr.detectChanges();
        });
    };
    VideoLogInfoComponent.prototype.ngOnDestroy = function () {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    };
    return VideoLogInfoComponent;
}(BaseComponent));
export { VideoLogInfoComponent };
